module.exports = __webpack_public_path__ + "static/media/0149_Small.74c6b8f3.jpg";